import { invariant } from "@searchui-searchforms/shared/utils";
import { useEventInstance } from "@/widgets/classic-form/form";
import { FieldComposer, fieldToConfig } from "@/features/form-fields";
import type { SpecialFieldItem } from "@/entities/form-metadata";
import { Grid } from "@/shared/components/Grid";

interface PlaceProps {
    field: SpecialFieldItem;
}

export const Place: React.FC<PlaceProps> = ({ field }) => {
    const fieldData = field.fields[0];
    invariant(fieldData, "Special place field metadata should be provided");

    const { instancePath, locationExactnessPath, setLocation, clearLocation } = useEventInstance({
        eventName: "Self",
    });

    const handleChange = (value: Record<string, unknown>) => {
        const isClearing = !value.location && !value.gpid;

        if (isClearing) {
            clearLocation();
        } else {
            setLocation(value as { location: string; gpid: string });
        }
    };

    // TODO: for special place label should be shown, add once refactoring of base-field related finalized
    return (
        <Grid.Field spanDesktop={9} spanTablet={8} spanMobile={12}>
            <FieldComposer
                fieldPath={instancePath}
                exactnessFieldPath={locationExactnessPath}
                fieldConfig={fieldToConfig(fieldData)}
            >
                <FieldComposer.Label />
                <FieldComposer.FieldConnector>
                    {({ formField, fieldConfig }, id) => (
                        <FieldComposer.Inputs.Place
                            id={id}
                            {...formField}
                            placeholder={fieldData.meta.placeHolder?.text}
                            data-testid={`placeInput-${instancePath}`}
                            required={fieldConfig.required}
                            onChange={handleChange}
                        />
                    )}
                </FieldComposer.FieldConnector>
                <FieldComposer.PlaceExactness />
            </FieldComposer>
        </Grid.Field>
    );
};
